import normalize from '@sparta.global.utilities/normalize/dist/es6.js';

/**
 * Sanitizes Structured Data JSON provided by iProspect and returns it as a String
 * @example sanitizeStructuredData(Object);
 * @param {Object} data is read from the JCR (JSON provided by iProspect)
 * @returns {String} sanitized Structured Data JSON as a String
 */
function sanitizeStructuredData(data) {
  const keyRenames = {
    context: '@context',
    type: '@type',
    graph: '@graph',
    id: '@id'
  };
  const ignoreKeys = ['SI_TRADUC', 'NO_TRADUC'];
  /**
   * A recursive analysis of the structuredData object
   * @param {object} o the structuredData object, or an object within it
   * @returns {object} either an array or an object
   */
  function renameKeys(o) {
    let object;
    if (Array.isArray(o)) {
      object = [];
      o.forEach(item => {
        // if this is an object, recurse
        if (typeof item === 'object') {
          object.push(renameKeys(item));
        } else {
          object.push(item);
        }
      });
    } else {
      object = {};
      Object.keys(o).forEach(key => {
        let value;
        // get destination key
        const destKey = keyRenames[key] || key;
        // get the value
        value = o[key];
        // if this is an object, recurse
        if (typeof value === 'object') {
          value = renameKeys(value);
        }
        // set it on the result using the destination key
        if (!ignoreKeys.includes(key)) {
          if (typeof value !== 'object') {
            object[destKey] = normalize(value);
          } else {
            object[destKey] = value;
          }
        }
      });
    }
    return object;
  }
  const structuredDataObject = renameKeys(data);
  return JSON.stringify(structuredDataObject, undefined, 2); /* pretty */
  // return JSON.stringify(structuredDataObject); /* minified */
}

export { sanitizeStructuredData as default };
